var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection14Feat1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76562 1.34637C9.76562 0.602797 10.3901 0 11.1604 0C11.9307 0 12.5551 0.602797 12.5551 1.34637V9.4246C12.5551 10.1682 11.9307 10.771 11.1604 10.771C10.3901 10.771 9.76562 10.1682 9.76562 9.4246V1.34637Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0781 1.34637C32.0781 0.602797 32.7026 0 33.4729 0C34.2432 0 34.8676 0.602797 34.8676 1.34637V9.4246C34.8676 10.1682 34.2432 10.771 33.4729 10.771C32.7026 10.771 32.0781 10.1682 32.0781 9.4246V1.34637Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5555 25.5824H9.76605V28.2751H12.5555V25.5824ZM9.76605 22.8896C8.22541 22.8896 6.97656 24.0952 6.97656 25.5824V28.2751C6.97656 29.7623 8.22541 30.9679 9.76605 30.9679H12.5555C14.0962 30.9679 15.345 29.7623 15.345 28.2751V25.5824C15.345 24.0952 14.0962 22.8896 12.5555 22.8896H9.76605Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7118 25.5824H20.9223V28.2751H23.7118V25.5824ZM20.9223 22.8896C19.3817 22.8896 18.1328 24.0952 18.1328 25.5824V28.2751C18.1328 29.7623 19.3817 30.9679 20.9223 30.9679H23.7118C25.2524 30.9679 26.5013 29.7623 26.5013 28.2751V25.5824C26.5013 24.0952 25.2524 22.8896 23.7118 22.8896H20.9223Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8719 25.5824H32.0825V28.2751H34.8719V25.5824ZM32.0825 22.8896C30.5418 22.8896 29.293 24.0952 29.293 25.5824V28.2751C29.293 29.7623 30.5418 30.9679 32.0825 30.9679H34.8719C36.4126 30.9679 37.6614 29.7623 37.6614 28.2751V25.5824C37.6614 24.0952 36.4126 22.8896 34.8719 22.8896H32.0825Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5555 36.3539H9.76605V39.0466H12.5555V36.3539ZM9.76605 33.6611C8.22541 33.6611 6.97656 34.8667 6.97656 36.3539V39.0466C6.97656 40.5338 8.22541 41.7394 9.76605 41.7394H12.5555C14.0962 41.7394 15.345 40.5338 15.345 39.0466V36.3539C15.345 34.8667 14.0962 33.6611 12.5555 33.6611H9.76605Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7118 36.3539H20.9223V39.0466H23.7118V36.3539ZM20.9223 33.6611C19.3817 33.6611 18.1328 34.8667 18.1328 36.3539V39.0466C18.1328 40.5338 19.3817 41.7394 20.9223 41.7394H23.7118C25.2524 41.7394 26.5013 40.5338 26.5013 39.0466V36.3539C26.5013 34.8667 25.2524 33.6611 23.7118 33.6611H20.9223Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.57897 8.07946H39.0528C40.5934 8.07946 41.8422 9.285 41.8422 10.7722V32.3141C42.8055 32.3141 43.7402 32.4319 44.6317 32.6534V10.7722C44.6317 7.79788 42.1339 5.38672 39.0528 5.38672H5.57897C2.49779 5.38672 0 7.79788 0 10.7722V43.0851C0 46.0594 2.49779 48.4706 5.57897 48.4706H32.1771C31.6776 47.6372 31.2906 46.7331 31.0358 45.7779H5.57897C4.03838 45.7779 2.78948 44.5723 2.78948 43.0851V10.7722C2.78948 9.285 4.03838 8.07946 5.57897 8.07946Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2329 20.1966H1.39062V17.5039H43.2329V20.1966Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8415 51.1636C46.4633 51.1636 50.21 47.5469 50.21 43.0854C50.21 38.624 46.4633 35.0072 41.8415 35.0072C37.2198 35.0072 33.4731 38.624 33.4731 43.0854C33.4731 47.5469 37.2198 51.1636 41.8415 51.1636ZM41.8415 53.8564C48.0039 53.8564 52.9995 49.0341 52.9995 43.0854C52.9995 37.1368 48.0039 32.3145 41.8415 32.3145C35.6791 32.3145 30.6836 37.1368 30.6836 43.0854C30.6836 49.0341 35.6791 53.8564 41.8415 53.8564Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.844 36.5947C42.6143 36.5947 43.2387 37.1975 43.2387 37.9411V43.7279L46.6579 46.0191C47.2907 46.443 47.4476 47.282 47.0083 47.8928C46.5691 48.5037 45.7 48.6551 45.0672 48.2311L40.4492 45.1368V37.9411C40.4492 37.1975 41.0736 36.5947 41.844 36.5947Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection14Feat1);
export default __webpack_public_path__ + "static/media/section14Feat1.1d623b5e2b3452ed344e6f8a327bf5ad.svg";
export { ForwardRef as ReactComponent };